import Vue from 'vue'
import LaddaButton from 'codium-ladda-button'
import HelpBlock from 'components/form/HelpBlock'
import LoadingSpinner from 'components/LoadingSpinner'
import NoResults from 'components/NoResults'
import LazyLoading from 'codium-lazy-loading'
import QuillWrapper from 'components/QuillWrapper'

Vue.component('ladda-button', LaddaButton)
Vue.component('help-block', HelpBlock)
Vue.component('loading-spinner', LoadingSpinner)
Vue.component('no-results', NoResults)
Vue.component('lazy-loading', LazyLoading)
Vue.component('quill-wrapper', QuillWrapper)
